module.exports = __webpack_public_path__ + "img/deploy-success.16b7aebb.png";